import React from 'react';
import notFound from '../../../../../../assets/flights-not-found.svg?reference';
import { NoResultsMessage } from '../../../../shared/components';
import { withTranslate } from '../../../../shared/i18n/translate';

export const FlightsNotFound = withTranslate<{}>(({ t }) => (
	<NoResultsMessage
		title={t('flight_list_empty_header')}
		body={t('flight_list_empty_body')}
		imageSource={notFound}
	/>
));
